import { requestJson } from './requestJson';
import { buildApiUrl } from './apiUrl';

const SHEET_ENDPOINT = buildApiUrl('/api/sheets-admin');

function authHeaders(accessToken) {
  if (!accessToken) {
    return {};
  }

  return {
    Authorization: `Bearer ${accessToken}`,
  };
}

export async function fetchSheets(accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    headers: {
      ...authHeaders(accessToken),
    },
  });
}

export async function fetchSheetsSnapshot(accessToken) {
  return requestJson(`${SHEET_ENDPOINT}?snapshot=1`, {
    headers: authHeaders(accessToken),
  });
}

export async function fetchSheetData(sheetName, accessToken) {
  return requestJson(
    `${SHEET_ENDPOINT}?sheetName=${encodeURIComponent(sheetName)}`,
    {
      headers: {
        ...authHeaders(accessToken),
      },
    }
  );
}

export async function fetchUsuariosLocationSuggestions(accessToken) {
  return requestJson(
    `${SHEET_ENDPOINT}?locationSuggestions=${encodeURIComponent('Usuarios')}`,
    {
      headers: {
        ...authHeaders(accessToken),
      },
    }
  );
}

export async function fetchRequestPendingCounts(accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'getRequestPendingCounts',
    }),
  });
}

export async function applyRequestRow(sheetName, rowIndex, accessToken, createdValue = '') {
  return requestJson(SHEET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'applyRequestRow',
      sheetName,
      rowIndex,
      createdValue,
    }),
  });
}

export async function patchRenameSheet(sheetName, newSheetName, accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'renameSheet',
      sheetName,
      newSheetName,
    }),
  });
}

export async function postCreateSheet(sheetName, accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'createSheet',
      sheetName,
    }),
  });
}

export async function deleteSheet(sheetName, accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'deleteSheet',
      sheetName,
    }),
  });
}

export async function patchRenameColumn(
  sheetName,
  currentColumnName,
  newColumnName,
  accessToken
) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'renameColumn',
      sheetName,
      currentColumnName,
      newColumnName,
    }),
  });
}

export async function postAddColumn(sheetName, newColumnName, accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'addColumn',
      sheetName,
      newColumnName,
    }),
  });
}

export async function deleteColumn(sheetName, columnName, accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'deleteColumn',
      sheetName,
      columnName,
    }),
  });
}

export async function postAddRow(sheetName, rowData, accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'addRow',
      sheetName,
      rowData,
    }),
  });
}

export async function patchUpdateRow(sheetName, rowIndex, rowData, accessToken, duplicateResolution = '') {
  return requestJson(SHEET_ENDPOINT, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'updateRow',
      sheetName,
      rowIndex,
      rowData,
      duplicateResolution,
    }),
  });
}

export async function deleteRow(
  sheetName,
  rowIndex,
  accessToken,
  targetEmail = '',
  deletionNote = '',
  replacementValue = ''
) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'deleteRow',
      sheetName,
      rowIndex,
      targetEmail,
      deletionNote,
      replacementValue,
      roleReplacementName: replacementValue,
    }),
  });
}

export async function postInitializeSchema(accessToken) {
  return requestJson(SHEET_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(accessToken),
    },
    body: JSON.stringify({
      action: 'initializeSchema',
    }),
  });
}
